export default {
    /*Tabs.jsx*/
    message_1_01: "Wählen Sie Bereich:",
    message_1_02: "24 Stunden",
    message_1_03: "Woche",
    message_1_04: "Monat",
    /*Analytics.jsx*/
    message_2_01: "Übersicht",
    message_2_02: "Gesamtbesucher",
    message_2_03: "Neue Benutzer",
    message_2_04: "Benutzer zurückkehren",
    message_2_05: "Die letzten 24 Stunden",
    message_2_06: "Die letzte Woche",
    message_2_07: "Der letzte Monat",
    message_2_08: "Betriebssystem",
    message_2_09: "Daten Download vs Upload",
    message_2_10: "Smartphone, Tabletten, Notizbücher",
    message_2_11: "Neue vs zurückkehrende Benutzer",
    message_2_12: "Gesamtbesuche",
    message_2_13: "Laden",
    /*App.jsx*/
    message_3_01: "Zurücksetzen",
    message_3_02: "Analytik",
    message_3_03: "Einstellungen",
    message_3_04: "FAQs",
    message_3_05: "Sprache:",
    message_3_06: "Abmelden",
    /*RegistrationState.jsx*/
    message_4_01: "Zurücksetzen",
    message_4_02: "Nähere",
    message_4_03: "Einstellungen",
    message_4_04: "Branding",
    message_4_05: "Komplett",
    /*DetailsState.jsx*/
    message_5_01: "Bitte geben Sie die Details Ihres Standorts an, ",
    message_5_02: "so dass Sie von Ihren Kunden gefunden werden können",
    message_5_03: "Firmenname",
    message_5_04: "Art des Geschäfts",
    message_5_05: "Passen Sie Ihren Wi-Fi-Service an oder klicken Sie auf, um die Standardeinstellungen zu verwenden. Sie können zurückkommen und diese zu einem späteren Zeitpunkt bearbeiten.",
    message_5_06: "Überspringen",
    message_5_07: "Weiter",
    message_5_08: "Bitte geben Sie den Firmennamen ein",
    message_5_09: "Ihr Firmenname darf {ruleValue} Zeichen nicht überschreiten",
    message_5_10: "Bitte wählen Sie Ihre Business Type",
    message_5_11: "Kaffeehaus",
    message_5_12: "Restaurant",
    message_5_13: "Bekleidungsgeschäft",
    message_5_14: "Andere",
    /*SettingsState.jsx*/
    message_6_01: "Verwalten Sie Ihre Wi-Fi-Einstellungen",
    message_6_02: "Zeit des kostenlosen Wi-Fi",
    message_6_03: "Wählen Sie, wie viel freie Wi-Fi-Zeit Sie Ihren Kunden anbieten möchten",
    message_6_04: "Zeit des kostenlosen Wi-Fi",
    message_6_05: "Keine Begrenzung",
    message_6_06: "15 Minuten",
    message_6_07: "30 Minuten",
    message_6_08: "45 Minuten",
    message_6_09: "1 Stunde",
    message_6_10: "4 Stunden",
    message_6_11: "Sozialen Medien Links",
    message_6_12: "Sozialen medien Links",
    message_6_13: "Zurück",
    message_6_14: "Weiter",
    message_6_15: "Bitte wähle die Zeit des kostenlosen Wi-Fi",
    message_6_16: "Ungültiges URL-Format für Facebook Link",
    message_6_17: "Ungültiges URL-Format für Twitter Link",
    message_6_18: "Ungültiges URL-Format für Foursquare Link",
    /*BrandingState.jsx*/
    message_7_01: "Passen Sie die Wi-Fi an Ihre Marke anpassen",
    message_7_02: "Wi-Fi-Service-Name",
    message_7_03: "Anpassen des Namens der Wi-Fi, die den Kunden angezeigt wird",
    message_7_04: "Wi-Fi-Name",
    message_7_05: "Benutzerdefinierte URL",
    message_7_06: "Externe Seite verwenden",
    message_7_07: "Eigene URL des Kunden",
    message_7_08: "Styling",
    message_7_09: "Wähle einen Stil, der deinem Geschäft entspricht",
    message_7_10: "Bild auswählen",
    message_7_11: "Swap Ad",
    message_7_12: "Eigene Anzeige hochladen",
    message_7_13: "Upload hochladen",
    message_7_14: "Zurück",
    message_7_15: "Weiter",
    message_7_16: "Bitte geben Sie den WLAN-Namen ein",
    message_7_17: "Ihr Wi-Fi-Name darf nicht überschreiten {ruleValue} Zeichen",
    message_7_18: "Bitte geben Sie die eigene URL des Kunden ein",
    message_7_19: "Ungültiges URL-Format für die eigene URL des Kunden",
    message_7_20: "Vorschau",
    /*CompleteState.jsx*/
    message_8_01: "Glückwunsche",
    message_8_02: "Du bist fast fertig",
    message_8_03: "Bitte klicken",
    message_8_04: "EINSTELLUNGEN",
    message_8_05: "Sparen",
    message_8_06: "um Änderungen an deinem Portal vorzunehmen.",
    message_8_07: "um dies zu einem späteren Zeitpunkt zu ändern",
    message_8_08: "SPAREN",
    message_8_09: "Du kannst immer wieder zu deinem",
    message_8_10: "Du bist fertig",
    message_8_11: "Jetzt kannst du dein Standardportal verwenden.",
    /*SaveConfirmation.jsx*/
    message_9_01: "Durch Klicken auf",
    message_9_02: "Weiter",
    message_9_03: "Du wählst die Standardvorlage zu überschreiben und deine eigenen Einstellungen auf dieses Portal anwenden",
    message_9_04: "Abbrechen",
    message_9_05: "Deine Änderungen wurden gespeichert und auf das Portal angewendet",
    message_9_06: "OK",
    message_9_07: "Irgendetwas geht falsch. Bitte versuchen Sie es abzumelden / melden Sie sich an und wiederholen Sie Ihre Aktionen oder wenden Sie sich an Ihren Provider",
    message_9_08: "OK",
    /*RedirectToManagementConsoleConfirmation.jsx*/
    message_10_01: "Du wirst den CBU Portal Setup-Assistenten verlassen, indem du auf",
    message_10_02: "Speichern und weiter",
    message_10_03: "Du wählst die Standardvorlage zu überschreiben und deine eigenen Einstellungen auf dieses Portal anwenden, indem du auf",
    message_10_04: "Abbrechen",
    message_10_05: "Du wählst alle Einstellungen auf den Standard zurück.",
    message_10_06: "Irgendetwas geht falsch. Bitte versuchen Sie es abzumelden / melden Sie sich an und wiederholen Sie Ihre Aktionen oder wenden Sie sich an Ihren Provider",
    message_10_07: "OK",
    /*ConfirmReset.jsx*/
    message_11_01: "Durch Klicken auf",
    message_11_02: "Weiter",
    message_11_03: "Sie wählen, um Ihre benutzerdefinierten Einstellungen zu entfernen und das Portal wird wieder auf die ursprünglichen Einstellungen zurückgesetzt.",
    message_11_04: "Abbrechen",
    /*Splash.jsx*/
    message_12_01: "Willkommen zu unserem kostenlosen WiFi-Zugang!",
    message_12_02: "Um sicher zu sein, dass deine Wartezeit schneller geht, haben wir sichergestellt, dass du in unserem Proximus-Zentrum kostenloses WiFi genießen kannst.",
    message_12_03: "Verbinden",
    message_12_04: "Bitte geben Sie unten Ihre Telefonnummer ein. Sie erhalten eine Nachricht, wenn Ihnen der kostenlose Zugang zu unserem Wi-Fi gewährt wird!",
    message_12_05: "Mobilnummer",
    message_12_06: "Ich stimme mit dem",
    message_12_07: "Allgemeine Geschäftsbedingungen",
    message_12_08: "und",
    message_12_09: "Datenschutzrichtlinie",
    message_12_10: "Registrieren",
    message_12_11: "Ich habe schon einen PIN-Code",
    message_12_12: "Angetrieben durch",
    /*Verification.jsx*/
    message_13_01: "Aktiviere dein Konto",
    message_13_02: "Bitte geben Sie den PIN-Code ein, den Sie erhalten haben:",
    message_13_03: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
    message_13_04: "PIN",
    message_13_05: "Einloggen",
    message_13_06: "Nummer ändern",
    message_13_07: "Neuer PIN-Code",
    message_13_08: "Angetrieben durch",
    /*Loading.jsx*/
    message_14_01: "Anschließen, bitte warten ...",
    /*Interstitial.jsx*/
    message_15_01: "Willkommen in unserem kostenlosen Wi-Fi",
    message_15_02: "Angetrieben durch",
    /*Success.jsx*/
    message_16_01: "Willkommen in unserem kostenlosen WiFi-Zugang!",
    message_16_02: "Um sicher zu gehen, dass deine Wartezeit schneller geht, haben wir sichergestellt, dass du in unserem Proximus-Zentrum kostenloses WiFi genießen kannst.",
    message_16_03: "Herzlichen Glückwunsch, du bist jetzt verbunden",
    message_16_04: "Genießen Sie, ohne Ihre Verbindung zum freien Internet zu warten, eine Dauer von 10 Minuten",
    message_16_05: "Angetrieben durch",
    /*PreviewWindow.jsx*/
    message_17_01: "Kundenspezifische Wi-Fi User Journey",
    message_17_02: "Anmeldung",
    message_17_03: "Überprüfen",
    message_17_04: "Laden",
    message_17_05: "Interstitielle",
    message_17_06: "Erfolg"
}


// WEBPACK FOOTER //
// ./src/locales/de.js